import React from "react";
import { Box, Grid, Paper } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import Loader3D from "../../../components/Loader/Loader3D";

const ChartSections = ({ dashBoardChart, year, loading }) => {
  const sample = new Array(12).fill(0);
  const incomeData = new Array(12).fill(0).map((_, i) => dashBoardChart?.[i]?.income ?? 0);
  const saleData   = new Array(12).fill(0).map((_, i) => dashBoardChart?.[i]?.saleAmt ?? 0);
  const expenseData= new Array(12).fill(0).map((_, i) => dashBoardChart?.[i]?.expense ?? 0);

  const options1 = {
    chart: { height: 350, type: "area", zoom: { enabled: false }, toolbar: { show: false } },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    xaxis: {
      type: "category",
      categories: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    },
    tooltip: { x: { formatter: (value) => value } },
    title: { text: `Income vs Sale (${year})`, align: "center", style: { fontSize: "16px", fontWeight: "bold" } },
  };

  const options2 = {
    chart: { height: 350, type: "area", zoom: { enabled: false }, toolbar: { show: false } },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    xaxis: {
      type: "category",
      categories: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    },
    tooltip: { x: { formatter: (value) => value } },
    title: { text: `Income vs Expense (${year})`, align: "center", style: { fontSize: "16px", fontWeight: "bold" } },
  };

  return (
    <Box mt={3}>
      {loading ? (
        <Box><Loader3D /></Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Paper elevation={5}>
              <ReactApexChart
                options={options1}
                series={[
                  { name: "Income", data: incomeData },
                  { name: "Sale", data: saleData },
                ]}
                type="area"
                height={350}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Paper elevation={5}>
              <ReactApexChart
                options={options2}
                series={[
                  { name: "Income", data: incomeData },
                  { name: "Expense", data: expenseData },
                ]}
                type="bar"
                height={350}
              />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ChartSections;
